<template>
    <div id="org" class="mt">
        <a-row type="flex" justify="start">
            <a-tooltip placement="topLeft">
                <template slot="title">
                    <span>{{ $t('generic.Add') }}</span>
                </template>
                <img @click="addOrg" class="sbxs" src="../../../assets/img/ss-add.png" width="22" height="22">
            </a-tooltip>
            <a-popconfirm
                    placement="bottom"
                    :title="$t('generic.AreyoudeleTask')"
                    @confirm="removeOrg"
                    :okText="$t('generic.Yes')"
                    :cancelText="$t('generic.No')"
            >
                <a-tooltip>
                    <template slot="title">
                        <span>{{$t('pubGicSet.Remove')}}</span>
                    </template>
                    <img style="margin-left: 4px;" class="sbxs" src="../../../assets/img/ss-delete.png" width="22" height="22">
                </a-tooltip>
            </a-popconfirm>
        </a-row>
        <a-row style="margin-top: 10px">
            <a-col :span="16">
                <vxe-table
                    border
                    resizable
                    highlight-hover-row
                    size="mini"
                    :data="tableData"
                    ref="orgTableRef">
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                    <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="key" :title="$t('reportSetting.CustCode')" minWidth="150"></vxe-table-column>
                    <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="value" :title="$t('reportSetting.CustName')"  minWidth="150"></vxe-table-column>
                </vxe-table>
            </a-col>
        </a-row>
        <a-modal
            :title="$t('generic.Add')"
            :visible="addVisible"
            width="50%"
            @cancel="handleCancel">
            <template slot="footer">
                <a-button type="primary" size="small" @click="saveAddSubmit">{{$t('publicLang.Save')}}</a-button>
            </template>
            <a-row type="flex" justify="start">
                <a-col>
                    <a-input :placeholder="$t('publicLang.PleaseEnter')" style="width: 150px;" size="small" v-model="SearchCode"/>
                </a-col>
                <a-col style="margin: 0 4px;">
                    <a-input :placeholder="$t('publicLang.PleaseEnter')" style="width: 150px;" size="small" v-model="SearchValue"/>
                </a-col>
                <a-col>
                    <a-button type="primary" size="small" @click="searchAddtableData">{{$t('publicLang.Search')}}</a-button>
                </a-col>
            </a-row>
            <a-row style="margin-top: 6px;">
                <vxe-table
                    border
                    resizable
                    highlight-hover-row
                    :data="addList"
                    size="mini"
                    ref="orgAddTableRef">
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                    <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="key" :title="$t('reportSetting.CustCode')"></vxe-table-column>
                    <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="value" :title="$t('reportSetting.CustName')"></vxe-table-column>
                </vxe-table>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
import ajax from '../../../api/ajax'
import api from '../../../api/url'
export default{
    props:{
        headerUid: {
            type: String,
            default: function() {
                return '';
            }
        },
    },
    data(){
        return{
            tableData: [], // 父表数据
            AddTableData: [], // add tabl data
            addVisible: false, // add 开关
            SearchValue: null, // add table 搜索条件
            SearchCode: null, // add table 搜索条件
            isSearch: false
        }
    },
    watch:{
        headerUid(v){
            this.init()
        }
    },
    created(){
        this.init()
    },
    computed:{
        addList(){
            if(this.isSearch){
                let newArr = this.AddTableData
                let code = this.SearchCode == null ? null : this.SearchCode.toUpperCase()
                let value = this.SearchValue == null ? null : this.SearchValue.toUpperCase()
                let result = []
                newArr.forEach(function (item, index) {
                    let key = item.key == null ? "" :item.key.toUpperCase()
                    let valueStr = item.value == null ? "" :item.value.toUpperCase()
                    if ((code == null ?  true: key.includes(code)) && ( value == null ? true: valueStr.includes(value))) {
                        result.push(item);
                    }
                });
                return result
            }else{
                return this.AddTableData
            }
        }
    },
    methods:{
//        初始话table
        init(){
            ajax.get(api.REPORTGENERICORGRTORG,{headerUid: this.headerUid}).then(res=>{
                this.tableData = res.data
            })
        },
        handleCancel(){
            this.addVisible = false;
            this.SearchCode = null;
            this.SearchValue = null;
        },
        addOrg(){
            this.addVisible = true
            ajax.get(api.REPORTGENERICORGLIST,{headerUid: this.headerUid}).then(res=>{
                this.AddTableData = res.data
            })
        },
        searchAddtableData(){
            this.isSearch = true
        },
        removeOrg(){
            let v = this.$refs.orgTableRef.getCheckboxRecords()
            if(v.length > 0){
            let data = this.tableData
                for(let i in this.tableData){
                    for(let t in v){
                        if(this.tableData[i].key == v[t].key){
                            this.tableData.splice(i,1)
                        }
                    }
                }
                let arr = []
                for(let i in data){
                    arr.push(data[i].key)
                }
                let params = {
                    headerUid: this.headerUid,
                    orgList: arr
                }
                ajax.post(api.REPORTGENERICORG,params).then(res=>{
                    this.$message.success(res.msg);
                    this.init()
                })
            }else{
                this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
            }
        },
        saveAddSubmit(){
            if(this.$refs.orgAddTableRef.getCheckboxRecords().length > 0){
                let arrData = [...this.$refs.orgAddTableRef.getCheckboxRecords(),...this.tableData]
                let arr = []
                for(let i in arrData){
                    arr.push(arrData[i].key)
                }
                let params = {
                    headerUid: this.headerUid,
                    orgList: arr
                }
                ajax.post(api.REPORTGENERICORG,params).then(res=>{
                    this.$message.success(res.msg);
                    this.init()
                    this.addVisible = false
                    this.SearchCode = null;
                    this.SearchValue = null;
                })
            }else{
                this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
            }

        }
    }
}
</script>